import ChooseAnotherID from './ChooseAnotherID';

export default ChooseAnotherID;
